/** Breathing room between the panel and the edges of the screen. */
export const VIEWPORT_MARGIN = 8

/** Gap between the bell and the panel hanging under it. */
export const ANCHOR_GAP = 10

/** How much of the panel must stay on screen. */
export const MIN_VISIBLE = 160

/** Width of the panel when the screen has room for it. */
export const PANEL_WIDTH = 380

export interface AnchorRect {
  bottom: number
  right: number
}

/** Pass `document.documentElement.clientWidth`: it excludes the scrollbar. */
export interface Viewport {
  width: number
  height: number
}

export interface PopoverOffsets {
  top: number
  right: number
  width: number
  maxHeight: number
}

/**
 * Where the notifications panel goes: under the bell, its right edge on the
 * bell's right edge, clamped so that the whole panel stays on screen.
 */
export function popoverOffsets(
  anchor: AnchorRect,
  viewport: Viewport
): PopoverOffsets {
  const width = Math.max(
    0,
    Math.min(PANEL_WIDTH, viewport.width - 2 * VIEWPORT_MARGIN)
  )

  const lowest = Math.max(VIEWPORT_MARGIN, viewport.height - MIN_VISIBLE)
  const top = Math.min(
    Math.max(anchor.bottom + ANCHOR_GAP, VIEWPORT_MARGIN),
    lowest
  )

  const furthestRight = Math.max(
    VIEWPORT_MARGIN,
    viewport.width - VIEWPORT_MARGIN - width
  )
  const right = Math.min(
    Math.max(VIEWPORT_MARGIN, viewport.width - anchor.right),
    furthestRight
  )

  return {
    top: Math.round(top),
    right: Math.round(right),
    width: Math.round(width),
    maxHeight: Math.round(
      Math.max(MIN_VISIBLE, viewport.height - top - VIEWPORT_MARGIN)
    )
  }
}
